import { Fragment, memo, ReactElement, useEffect, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import Form from './form';
import { PersonalDataVM } from 'shell/view-models/personal-data';
import { FormikErrors, FormikTouched } from 'formik';

interface AccordionFilterProps {
  onChange: (key: keyof PersonalDataVM, value: PersonalDataVM[keyof PersonalDataVM]) => void;
  values?: PersonalDataVM;
  disabled?: boolean;
  resetForm?: () => void;
  onChangeFields: (values: PersonalDataVM) => void;
  onSearch: () => void;
  personFilterAccountholderBlur?: (fieldName: string) => void;
  errors?: FormikErrors<PersonalDataVM>;
  touched?: FormikTouched<PersonalDataVM>;
}

const AccordionFilterComponent = ({
  onChange,
  values,
  disabled,
  resetForm,
  onChangeFields,
  onSearch,
  personFilterAccountholderBlur = () => {
    return;
  },
  errors,
  touched,
}: AccordionFilterProps): ReactElement => {
  const [open, setOpen] = useState<boolean>(!disabled);

  useEffect(() => {
    if (disabled) {
      setOpen(false);
    }
  }, [disabled]);

  const hasErrors = useMemo(() => {
    if (errors?.fiscalCode) {
      return true;
    }
    return false;
  }, [errors]);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter"
          id="filter"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          {errors ? hasErrors ? <Close color="error" /> : <Check color="success" /> : undefined}
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Form
            onChange={onChange}
            values={values}
            resetForm={resetForm}
            disabled={disabled}
            personFilterAccountholderBlur={personFilterAccountholderBlur}
            onChangeFields={onChangeFields}
            onSearch={() => {
              setOpen(false);
              onSearch();
            }}
            errors={errors}
            touched={touched}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionFilterComponent.displayName = 'Filtri persona accordion generalità intestatario pratiche';

const AccordionFilterAccountHolder = memo(AccordionFilterComponent);

export default AccordionFilterAccountHolder;
